import {reactive} from "vue";
import store from "@/store/store";
import {Patient} from "@/assets/js/patient";
import API from "../../assets/js/api";

export default reactive({
    patients: new Array(2),
    tipQueue: [], // {text: string, score: number, image: string }
    tutorial: false,
    tutorialtip: undefined,
    alertQueue: [],
    paused: false,
    score: 0,
    selectedSlot: -1,
    timeDelta: 0, // milliseconds since previous_time
    previous_time: Date.now(),
    game_active: false,
    game_over: false,
    game_speed: 1, // Multiplier. 1 for normal or 2 for fast
    resistanceRegion: "Low Antibiotic Resistance",
    start_time: 0,
    infoContent: undefined,
    StartGame(){
        this.start_time = Date.now();
        this.score = 0;
        this.game_over = false;
        this.getPatientForSlot(0);
        //this.getPatientForSlot(1);
        console.log("Typecheck", typeof this.patients[1])
        this.previous_time = Date.now();
        window.requestAnimationFrame(this.tick.bind(this));
        this.game_active = true;
        this.InitTutorial();
    },

    LoadGame(score, speed, start_time, patients){
        console.log(patients);
        this.score = score;
        this.game_speed = speed;
        this.start_time = start_time;
        this.game_over = false;
        store.dispatch("loadGameFromSave");
        for(let i=0; i < patients.length; i++){
            const basePatient = store.getters.getPatientByName(patients[i].name);
            const merged = Object.assign(basePatient, patients[i]);
            console.log(merged);
            this.patients[i] = reactive(new Patient(merged, this.patientDead(i, patients[i].name), patients[i].actions));
            this.patients[i].initialize();
            console.log(this.patients[i]);
        }
        this.previous_time = Date.now();
        window.requestAnimationFrame(this.tick.bind(this));
        this.game_active = true;
    },

    InitTutorial(){
        if(!this.tutorial) return;
        this.showTutorialTip({header: store.getters["getUIText"]("welcometoseptris"), text: store.getters["getUIText"]("septrisisagamethatw")});
        let buttons = store.getters.getButtons;
        for(let i=1; i< buttons.Labs.length; i++){
            this.patients[0].disableButton(buttons.Labs[i].text);
        }
        for(let i=1; i< buttons.Treatment.length; i++){
            this.patients[0].disableButton(buttons.Treatment[i].text);
        }
    },

    createSaveData(){
        let data = {
            patients: [],
        };
        data.score = this.score;
        data.speed = this.game_speed;
        data.start_time = this.start_time;
        if(this.patients[0]) data.patients.push(this.patients[0].createSave());
        if(this.patients[1]) data.patients.push(this.patients[1].createSave());
        return data;
    },

    saveGame(){
        if(!this.tutorial){
            store.commit("setSaveData", this.createSaveData());
            API.saveSession(store.getters["user/user_id"], store.getters["user/session_id"], store.getters.getSaveData)
                .catch(error=>{console.error(error)});
        }
    },

    getPatientForSlot(slot){
        let patientData = store.getters.getNewPatient;
        console.log(patientData);
        if(patientData && patientData.length === 0) {
            console.log("No patients!");
            this.game_over = true;
            this.game_active = false;
            return;
        }
        if(patientData){
            let patient = reactive(new Patient(patientData, this.patientDead(slot, patientData.name)));
            patient.initialize();
            this.patients[slot] = patient;
        } else {
            this.patients[slot] = null;
            if(this.patients[0] === null && this.patients[1] === null){
                console.log("No patients!");
                this.game_over = true;
                this.game_active = false;
            }
        }
        this.saveGame();
        console.log("typecheck", typeof this.patients[1], typeof this.patients[1] === undefined);
        if(slot === 0 && !this.patients[1] && store.getters.numCompletePatients > 0){
            this.getPatientForSlot(1);
        }
    },
    patientDead(index, name){
        return (tip)=>{
            console.log("Patient " + name + " dead.");
            tip.callback = ()=>this.getPatientForSlot(index);
            this.showTip(tip);
        }
    },
    selectPatient(patient){
        this.selectedSlot = this.patients.indexOf(patient);
    },
    pauseGame(){
        this.paused = true;
    },
    unpauseGame(){
        this.paused = false;
    },
    togglePause(){
        this.paused = !this.paused;
    },
    setGameSpeed(speed){
        this.game_speed = speed;
    },
    showTip(tip){
        this.pauseGame()
        this.tipQueue.push(tip);
    },
    clearTip(){
        if(this.tipQueue[0].score) this.score += this.tipQueue[0].score;
        this.tipQueue.shift();
        if (this.tipQueue.length <= 0){
            this.saveGame();
            this.unpauseGame();
        }
    },
    showTutorialTip(tip){
        this.tutorialtip = tip;
    },
    addAlert(alert){
        this.alertQueue.push(alert);
    },
    showInfo(id){
        this.pauseGame();
        this.infoContent = store.getters[id];
    },
    hideInfo(){
        this.infoContent  = undefined;
        this.unpauseGame();
    },
    tick(){
        let now = Date.now();
        this.timeDelta = (now - this.previous_time) * this.game_speed;
        this.previous_time = now;
        if(this.game_active){
            window.requestAnimationFrame(this.tick.bind(this));
        }
    }
});
